import { render, staticRenderFns } from "./enquiry.vue?vue&type=template&id=6e0485c0"
import script from "./enquiry.vue?vue&type=script&lang=js"
export * from "./enquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports